import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import { api } from "../../../../services/api/api.service";
import {toastr} from "react-redux-toastr";
import { API_DARTS_WEEKS } from "../../../../services/api/api.urls";
import { DartsWeeks, DartsWeeksData } from "./types";
import { COMPANY_ABBR } from "../../../../common/constants/company";
import { TryCatch } from "../../../../services/TryCatch";

const initialState: DartsWeeks = {
    dartsWeeks: [] as DartsWeeksData[],
    isLoading: true,
    isVisibleForm: false,
    editMode: false,
    editWeekId: null,
    noContent: null,
    totalItems: 0,
    totalPages: 0,
    pageNum: 1,
    pageSize: 10,
}

export interface IGetWeeksResponse {
    totalItems: 0,
    totalPages: 0,
    pageNum: 1,
    pageSize: 10,
    items: DartsWeeksData[]
}

export const getDartsWeeks = createAsyncThunk<IGetWeeksResponse, string, { rejectValue: string }>(
    'dartsWeeks/get',
    async (query, {rejectWithValue}) => {
        const result = await TryCatch(
            () => api.get(`${API_DARTS_WEEKS}?${query}`).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, 'Failed to fetch darts weeks.')
            return rejectWithValue(result.error);
        }
        return result.data;
    }
)

export const cmsWeeksSlice = createSlice({
    name: 'cmsWeeksPhases',
    reducers: {
        setPageNumber: (state, action) => {
            state.pageNum = action.payload
        },
        changePageSize: (state, action) => {
            state.pageSize = action.payload
        }
    },
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getDartsWeeks.fulfilled, (state, action) => {
                state.dartsWeeks = action.payload.items;
                state.noContent = !action.payload.items.length;
                state.isLoading = false;
                state.totalPages = action.payload.totalPages
            })
            .addCase(getDartsWeeks.rejected, (state) => {
                state.isLoading = false;
            })
    },
});

export const {setPageNumber,changePageSize} = cmsWeeksSlice.actions
export default cmsWeeksSlice.reducer;
